import { useCreateFolder } from "@/features/list/api/createFolder";
import { useDeleteFolder } from "@/features/list/api/deleteFolder";
import { useGetFolders } from "@/features/list/api/getFolders";
import { useUpdateFolderName } from "@/features/list/api/updateFolderName";
import { useCreateWorkflowInFolder } from "@/features/workflow/api/createWorkflowInFolder";
import { useCallback } from "react";

export const useFolderData = () => {
  const createFolderMutation = useCreateFolder();
  const updateFolderNameMutation = useUpdateFolderName();
  const deleteFolderMutation = useDeleteFolder();
  const createWorkflowInFolderMutation = useCreateWorkflowInFolder();
  const { data: folderList } = useGetFolders({});

  const handleCreateFolder = useCallback(
    async (name: string) => {
      try {
        await createFolderMutation.mutateAsync({
          data: {
            name,
          },
        });
      } catch (error) {
        throw error;
      }
    },
    [createFolderMutation]
  );

  const handleUpdateFolderName = useCallback(
    async (folder_id: string, name: string) => {
      try {
        await updateFolderNameMutation.mutateAsync({
          folder_id,
          data: {
            name,
          },
        });
      } catch (error) {
        throw error;
      }
    },
    [updateFolderNameMutation]
  );

  const handleDeleteFolder = useCallback(
    async (folder_id: string, selected_folder_label: string) => {
      try {
        await deleteFolderMutation.mutateAsync({
          folder_id,
          selected_folder_label,
        });
      } catch (error) {
        throw error;
      }
    },
    [deleteFolderMutation]
  );

  const handleCreateWorkflowInFolder = useCallback(
    async (
      folderId: string,
      workflowName: string,
      workflowType: "ocr" | "sorting"
    ) => {
      try {
        await createWorkflowInFolderMutation.mutateAsync({
          data: {
            workflow_name: workflowName,
            workflow_type: workflowType,
            folder_id: folderId,
          },
        });
      } catch (error) {
        throw error;
      }
    },
    [createWorkflowInFolderMutation]
  );

  return {
    isLoading:
      createFolderMutation.isLoading ||
      updateFolderNameMutation.isLoading ||
      deleteFolderMutation.isLoading ||
      createWorkflowInFolderMutation.isLoading,
    folderList,
    createFolder: handleCreateFolder,
    updateFolderName: handleUpdateFolderName,
    deleteFolder: handleDeleteFolder,
    createWorkflowInFolder: handleCreateWorkflowInFolder,
  };
};
